<template>
  <div>
    <template v-if="comments && comments.length > 0">
      <ul v-if="$fetchState.pending" class="comment-list">
        <li>
          <div class="skeleton">
            <div></div>
            <p></p>
          </div>
        </li>
        <li>
          <div class="skeleton">
            <div></div>
            <p></p>
          </div>
        </li>
      </ul>
      <div v-else-if="$fetchState.error" class="callout callout-error">Error loading comments.</div>
      <div v-else-if="loadingError" class="callout callout-error"></div>
      <template v-else>
        <template v-if="showCappedComments">
          <ul class="comment-list">
            <comment-item
              v-for="comment in cappedComments"
              :key="comment.id"
              :resource-id="resourceId"
              :comment="comment"
              :can-reply="true"
            />
          </ul>
        </template>
        <template v-else>
          <ul class="comment-list">
            <comment-item
              v-for="comment in comments"
              :key="comment.id"
              :resource-id="resourceId"
              :comment="comment"
              :can-reply="true"
            />
          </ul>
        </template>
        <template v-if="showToggle">
          <t-button
            v-if="isLoading"
            class="tw-text-link hover:tw-text-link-dark focus:tw-text-link-dark"
            size="sm"
            disabled
          >
            Loading...
          </t-button>
          <t-button
            v-else
            class="tw-text-link hover:tw-text-link-dark focus:tw-text-link-dark"
            size="sm"
            @click="toggleShowAll"
          >
            <template v-if="showAll">Show fewer comments&nbsp;</template>
            <template v-else>Show more comments&nbsp;</template>
          </t-button>
        </template>
      </template>
    </template>

    <p v-else class="text-mute"><small>No comments yet.</small></p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CommentItem from './CommentItem.vue';
import TButton from '~/components/atoms/t-button.vue';
export default {
  name: 'CommentList',
  components: {
    CommentItem,
    TButton,
  },
  props: {
    showLoadMoreButton: { type: Boolean, default: false },
    resourceId: { type: Number, default: null }, // Pass this to the comment form
    type: { type: String, default: 'comment' },
    maxCommentCount: { type: Number, default: 2 },
    eventParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      loadingError: null,
      showAll: false,
      page: 1,
      size: 0,
      totalPages: 0,
    };
  },
  async fetch() {
    await this.loadComments(this.$route.query.page ?? 1);
  },
  fetchKey() {
    return `comment-list:${this.resourceId}`;
  },
  computed: {
    ...mapGetters(['comments']),
    cappedComments() {
      return this.comments.slice(0, this.maxCommentCount);
    },
    showToggle() {
      return this.showLoadMoreButton && this.maxCommentCount < this.comments.length;
    },
    showCappedComments() {
      return this.showToggle && !this.showAll;
    },
  },
  methods: {
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
    async loadComments(page) {
      const params = { id: this.resourceId };
      let action = 'loadComments';

      // Handle different types of comments from different endpoints
      switch (this.type) {
        case 'suggestion':
          action = 'loadSuggestions';
          break;
        case 'error':
          action = 'loadErrors';
          break;
      }

      if (page) {
        params.page = page;
      }

      // Disable the Load More button until new items loaded
      this.isLoading = true;

      try {
        const response = await this.$store.dispatch(action, params);

        this.size = response.size;
        this.totalPages = response.totalPages;
        this.page = response.page;

        // Append to list of resources
        //this.comments = append ? this.comments.concat(response.list) : response.list;
      } catch (err) {
        throw new Error(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
